import { render } from "./BankAndPayment.vue?vue&type=template&id=31bd9737&scoped=true"
import script from "./BankAndPayment.vue?vue&type=script&lang=js"
export * from "./BankAndPayment.vue?vue&type=script&lang=js"

import "./BankAndPayment.vue?vue&type=style&index=0&id=31bd9737&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bd9737"]])

export default __exports__